const labels = [
  {
    keyindex: 0,
    value: 0,
    label: "bint",
    isFS: false,
    requiresBlankFile: false,
    acceptedSizeText: {
      eSizes: "130x457",
      lSizes: "160x640",
      pSizes: "672x210"
    },
    pixels: {
      ePixels: [59410],
      lPixels: [102400],
      pPixels: [141120]
    },
    productAvailableForDirect: true,
    productAvailableForProgrammatic: false
  },
  {
    keyindex: 1,
    value: 1,
    label: "fsa",
    isFS: true,
    requiresBlankFile: false,
    acceptedSizeText: {
      eSizes: "640x480",
      lSizes: "1024x680, 1024x576",
      pSizes: "720x960 img, 540x960 vid"
    },
    pixels: {
      ePixels: [307200],
      lPixels: [589824, 696320],
      pPixels: [518400, 691200]
    },
    productAvailableForDirect: true,
    productAvailableForProgrammatic: true
  },
  {
    keyindex: 2,
    value: 2,
    label: "fsbi",
    isFS: true,
    requiresBlankFile: true,
    acceptedSizeText: {
      eSizes: "640x480",
      lSizes: "1024x680",
      pSizes: "720x960"
    },
    pixels: { ePixels: [307200], lPixels: [696320], pPixels: [691200] },
    productAvailableForDirect: true,
    productAvailableForProgrammatic: false
  },
  {
    keyindex: 3,
    value: 3,
    label: "hfsp",
    isFS: false,
    requiresBlankFile: true,
    acceptedSizeText: {
      eSizes: "620x278",
      lSizes: "982x432",
      pSizes: "672x610"
    },
    pixels: { ePixels: [172360], lPixels: [424224], pPixels: [409920] },
    productAvailableForDirect: false,
    productAvailableForProgrammatic: false
  },
  {
    keyindex: 4,
    value: 4,
    label: "vsa",
    isFS: false,
    requiresBlankFile: true,
    acceptedSizeText: {
      eSizes: "234x416",
      lSizes: "360x640",
      pSizes: "360x640"
    },
    pixels: { ePixels: [97344], lPixels: [230400], pPixels: [230400] },
    productAvailableForDirect: false,
    productAvailableForProgrammatic: false
  }
];

module.exports = { data: labels };
